







































import { DataImportFile } from '@/shared/data-import-file';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const usersModule = namespace('users');

@Component
export default class DataImportsTable extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) private dataImportFiles!: Array<DataImportFile>;
    @Prop({ required: true }) private page!: number;
    @Prop({ required: true }) private pageSize!: number;
    @Prop({ required: true }) private total!: number;

    private currentPage: number = this.page;

    private get dataImportFileFields(): Array<{}> {
        return [
            { key: 'status', label: 'Status' },
            { key: 'filename', label: 'Filename' },
            { key: 'type', label: 'Type' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'createdBy', label: 'Upload By' },
            { key: 'createdDate', label: 'Upload Date' },
            { key: 'createdTime', label: 'Upload Time' },
            { key: 'successfulRows', label: 'Imported Records' },
            { key: 'failedRows', label: 'Failed Records' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private get paginationDescription(): string {
        const start = this.dataImportFiles.length < 1 ? 0 : ((this.currentPage - 1) * this.pageSize) + 1;
        const end = start + this.pageSize > this.total ? this.total : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    @Watch('page')
    private onPageChanged(page: number): void {
        this.currentPage = page;
    }

    @Watch('currentPage')
    private onCurrentPageChanged(): void {
        this.$emit('page-changed', this.currentPage);
    }

    private typeDescription(type: number): string {
        switch (type) {
            case 0:
                return 'New Data';
            case 1:
                return 'Cleansed Data';
            case 2:
                return 'Pipeline Data';
            default:
                return '';
        }
    }

    private userDescription(userId: string): string {
        const user = this.users.find((u) => u.id === userId);
        return user == null ? '' : `${user.firstName == null ? '' : user.firstName.trim()} ${user.lastName == null ? '' : user.lastName.trim()}`;
    }
}
